import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '@/router'
import Vue from 'vue'




// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // API的base_url
  timeout: Number(process.env.VUE_APP_TIMEOUT) || 15000, // 请求超时时间
  withCredentials: true, // 跨域请求时是否需要使用凭证
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求计数器
let loadingInstance = null
let requestCount = 0

// 显示loading
const showLoading = () => {
  if (requestCount === 0 && !loadingInstance) {
    loadingInstance = Loading.service({
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)',
      spinner: 'el-icon-loading'
    })
  }
  requestCount++
}

// 隐藏loading
const hideLoading = () => {
  requestCount--
  if (requestCount === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送前显示loading
    // showLoading()

    // 从localStorage获取token
    const token = localStorage.getItem('token')
    
    // 如果token存在，则添加到请求头
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    // 如果是get请求，添加时间戳参数，避免缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }

    return config
  },
  error => {
    // 请求错误时隐藏loading
    // hideLoading()
    // 请求错误处理
    Message.error('请求错误，请稍后重试')
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应后隐藏loading
    // hideLoading()

    // 获取响应数据
    const res = response.data

    // 根据自定义状态码判断请求是否成功
    if (res.code === 200 || res.code === 0) {
      // 请求成功，返回完整响应数据
      return res
    } else if (res.code === 401) {
      localStorage.removeItem('token')
      return Promise.reject(new Error('Unauthorized'))
    }else if(res.code === 500){
      Vue.prototype.$toast.error(res.msg || '请求失败')
      return Promise.reject(res.msg || '请求失败')
    } else {
      // 其他错误
      Vue.prototype.$toast.error(res.msg || '请求失败')
      return Promise.reject(res.msg || '请求失败')
    }
  },
  error => {
    // 响应错误时隐藏loading
    // hideLoading()

    // 处理HTTP错误状态码
    let message = '请求失败'
    if (error.response) {
      const status = error.response.status
      switch (status) {
        case 400:
          message = '请求错误'
          break
        case 401:
          message = '未授权，请登录'
          localStorage.removeItem('token')
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址出错'
          break
        case 408:
          message = '请求超时'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 501:
          message = '服务未实现'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        case 504:
          message = '网关超时'
          break
        case 505:
          message = 'HTTP版本不受支持'
          break
        default:
          message = `未知错误(${status})`
      }
    } else if (error.message.includes('timeout')) {
      message = '请求超时，请检查网络'
    } else if (error.message.includes('Network Error')) {
      message = '网络错误，请检查网络连接'
    }

    Message.error(message)
    return Promise.reject(error)
  }
)

// 封装请求方法
const http = {
  /**
   * GET请求
   * @param {string} url - 请求地址
   * @param {object} params - 请求参数
   * @param {object} config - 额外配置
   * @returns {Promise}
   */
  get(url, params = {}, config = {}) {
    return service.get(url, { params, ...config })
  },

  /**
   * POST请求
   * @param {string} url - 请求地址
   * @param {object} data - 请求数据
   * @param {object} config - 额外配置
   * @returns {Promise}
   */
  post(url, data = {}, config = {}) {
    return service.post(url, data, config)
  },

  /**
   * PUT请求
   * @param {string} url - 请求地址
   * @param {object} data - 请求数据
   * @param {object} config - 额外配置
   * @returns {Promise}
   */
  put(url, data = {}, config = {}) {
    return service.put(url, data, config)
  },

  /**
   * DELETE请求
   * @param {string} url - 请求地址
   * @param {object} params - 请求参数
   * @param {object} config - 额外配置
   * @returns {Promise}
   */
  delete(url, params = {}, config = {}) {
    return service.delete(url, { params, ...config })
  },

  /**
   * 上传文件
   * @param {string} url - 上传地址
   * @param {FormData} formData - 表单数据
   * @param {function} onUploadProgress - 上传进度回调
   * @returns {Promise}
   */
  upload(url, formData, onUploadProgress = null) {
    return service.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onUploadProgress ? progressEvent => {
        const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
        onUploadProgress(complete)
      } : null
    })
  },

  /**
   * 下载文件
   * @param {string} url - 下载地址
   * @param {object} params - 请求参数
   * @param {string} filename - 文件名
   * @returns {Promise}
   */
  download(url, params = {}, filename = '') {
    return service.get(url, {
      params,
      responseType: 'blob'
    }).then(response => {
      // 创建blob链接
      const blob = new Blob([response])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      
      // 设置文件名
      if (filename) {
        link.download = filename
      } else {
        // 尝试从响应头获取文件名
        const disposition = response.headers['content-disposition']
        if (disposition && disposition.includes('filename=')) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          const matches = filenameRegex.exec(disposition)
          if (matches && matches[1]) {
            link.download = matches[1].replace(/['"]/g, '')
          }
        }
      }
      
      // 触发下载
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
      
      return response
    })
  }
}

export default http 